<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(['screenSize']),
    },
    beforeCreate() {
        const brand = process.env.VUE_APP_BRAND || 'lawnstarter';
        document.body.classList.add(`themed-${brand}`);
    },
};
</script>

<style lang="scss"></style>
